import { ZoomOAuthPage } from '@features/auth/components/ZoomOAuthPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/zoom/callback')({ component: ZoomOAuthPage });
